import { useRef, useEffect, useState } from "react";
//import Dashboard from "./Dashboard";
import Clientes from "./Clientes";
import Todo from "./Todo";
import { useLocation } from "react-router-dom";
//import Contratos from "./Contratos";
//import BuroJudicial from "./BuroJudicial";
import Corte from "./Corte";
import Tickets from "./Tickets";
function SelectedTab({link}){
    switch(link){
        // case '/dashboard':
        //     return <Dashboard />
        case '/contrato/clientes':
            return <Clientes></Clientes>
        case '/todo/tree':
            return <Todo />
        case '/todo/list':
            return <Todo />
        case '/tickets':
            return <Tickets />
        case '/corte/busquedas-realizadas':
            return <Corte />
        case '/corte/traslados':
            return <Corte />
        case '/corte/otros-conceptos':
            return <Corte />
        case '/corte/corte-de-caja':
            return <Corte />
        case '/corte/resumen':
            return <Corte />
        default:
            return <Clientes />
    }
}

export default function SubAside() {

    const {pathname} = useLocation();
    const secondaryRef = useRef(null);
    const [heightSidebar, setHeightSidebar] = useState(0);

    useEffect(() => {

        function onResize() {
            const {height} = secondaryRef.current.getBoundingClientRect();
            setHeightSidebar(height);
        }

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize)
        };

    }, []);

    return (
        <>
            <div className="aside-secondary d-flex flex-row-fluid">
                <div className="aside-workspace py-5 ps-5 pe-2">
                    <div className="d-flex h-100 flex-column">
                        <div ref={secondaryRef}  className="flex-column-fluid hover-scroll-y" style={{height : heightSidebar}}>
                            <SelectedTab link={pathname}/>
                        </div>
                        <div className="flex-column-auto pt-10 px-5">
                            <button className="btn btn-bg-light btn-color-gray-600 btn-flex btn-active-color-primary flex-center w-100 d-none">
                                <span className="btn-label">
                                    Documentaci&oacute;n / Manuales
                                </span>
                                <i className="ki-outline ki-document btn-icon fs-4 ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
